import List from "./List";
import New from "./New";
import Wrapper from "./Wrapper";

export default {
  List,
  New,
  Wrapper
};
